import { gql } from '@apollo/client';

// ============================================================================
// FRAGMENTS
// ============================================================================

export const CATEGORIA_GASTO_FRAGMENT = gql`
  fragment CategoriaGastoFields on CategoriaGasto {
    id
    nombre
    descripcion
    color
    icono
    activa
    total_gastos
    cantidad_gastos
  }
`;

export const PROVEEDOR_FRAGMENT = gql`
  fragment ProveedorFields on Proveedor {
    id
    nombre
    nombre_comercial
    nit
    digito_verificacion
    tipo_persona
    tipo_documento
    contacto_nombre
    contacto_telefono
    contacto_email
    direccion
    ciudad
    condiciones_pago
    dias_credito
    descuento_pronto_pago
    categoria
    notas
    activo
    total_compras
    total_gastos
    created_at
    updated_at
  }
`;

// ============================================================================
// QUERIES - CATEGORIAS GASTO
// ============================================================================

export const GET_CATEGORIAS_GASTO = gql`
  ${CATEGORIA_GASTO_FRAGMENT}
  query GetCategoriasGasto($activa: Boolean) {
    categoriasGasto(activa: $activa) {
      ...CategoriaGastoFields
    }
  }
`;

// ============================================================================
// QUERIES - PROVEEDORES
// ============================================================================

export const GET_PROVEEDORES = gql`
  ${PROVEEDOR_FRAGMENT}
  query GetProveedores($activo: Boolean, $busqueda: String, $categoria: String) {
    proveedores(activo: $activo, busqueda: $busqueda, categoria: $categoria) {
      ...ProveedorFields
    }
  }
`;

export const GET_PROVEEDOR = gql`
  ${PROVEEDOR_FRAGMENT}
  query GetProveedor($id: Int!) {
    proveedor(id: $id) {
      ...ProveedorFields
    }
  }
`;

// ============================================================================
// MUTATIONS - CATEGORIAS GASTO
// ============================================================================

export const CREAR_CATEGORIA_GASTO = gql`
  ${CATEGORIA_GASTO_FRAGMENT}
  mutation CrearCategoriaGasto($input: CrearCategoriaGastoInput!) {
    crearCategoriaGasto(input: $input) {
      ...CategoriaGastoFields
    }
  }
`;

export const ACTUALIZAR_CATEGORIA_GASTO = gql`
  ${CATEGORIA_GASTO_FRAGMENT}
  mutation ActualizarCategoriaGasto($id: Int!, $input: ActualizarCategoriaGastoInput!) {
    actualizarCategoriaGasto(id: $id, input: $input) {
      ...CategoriaGastoFields
    }
  }
`;

export const ELIMINAR_CATEGORIA_GASTO = gql`
  ${CATEGORIA_GASTO_FRAGMENT}
  mutation EliminarCategoriaGasto($id: Int!) {
    eliminarCategoriaGasto(id: $id) {
      ...CategoriaGastoFields
    }
  }
`;

// ============================================================================
// MUTATIONS - PROVEEDORES
// ============================================================================

export const CREAR_PROVEEDOR = gql`
  ${PROVEEDOR_FRAGMENT}
  mutation CrearProveedor($input: CrearProveedorInput!) {
    crearProveedor(input: $input) {
      ...ProveedorFields
    }
  }
`;

export const ACTUALIZAR_PROVEEDOR = gql`
  ${PROVEEDOR_FRAGMENT}
  mutation ActualizarProveedor($id: Int!, $input: ActualizarProveedorInput!) {
    actualizarProveedor(id: $id, input: $input) {
      ...ProveedorFields
    }
  }
`;

export const ELIMINAR_PROVEEDOR = gql`
  ${PROVEEDOR_FRAGMENT}
  mutation EliminarProveedor($id: Int!) {
    eliminarProveedor(id: $id) {
      ...ProveedorFields
    }
  }
`;
